module.exports = __webpack_public_path__ + "static/media/ls.ae709507.svg";